<style scoped>
.contenedor {
    margin-top: 6%;
    padding-left: 5%;
    padding-right: 5%;
    margin-bottom: 2%;
}

.image-container {
    position: relative;
    width: 100%;
    height: 100%;
}

.modal-image {
    width: 100%;
    height: auto;
    transition: transform 0.3s ease-in-out;
    /* Animación suave para el zoom */
}

.custom-icon {
    font-size: 3rem;
    color: #ff9900;

}

.parallax-section {
    position: relative;
    background-color: #3498db;
    /* Fondo simple */
    height: 500px;
    transition: transform 0.3s ease-out;
}

.parallax-section.scrolled {
    transform: translateY(-20px);
    /* Efecto de desplazamiento */
}

.sticky-col {
    position: sticky;
    top: 80px;
    /* Ajusta según tu header o espacio superior */
    height: calc(100vh - 80px);
    /* Para que tome altura completa menos lo que queda arriba */
    overflow-y: auto;
    /* Para scroll interno si el contenido es muy largo */
}

.img-uniforme {
    width: 300px;
    /* ancho fijo deseado */
    height: 200px;
    /* alto fijo deseado */
    object-fit: cover;
    /* recorta y escala para llenar sin distorsión */
    display: block;
}

.boton-con-sombra {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    transition: box-shadow 0.3s ease;
}

.boton-con-sombra:hover {
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.3);
}

ul::-webkit-scrollbar {
    height: 0px;
}

.card:hover {
    transform: scale(1.03);
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
}

@media (max-width: 768px) {
    .contenedor {
        margin-top: 15%;
    }
}
</style>

<template>
    <div v-if="loading" style="margin-top: 18%;">
        <div class="loader">
            <svg class="car" width="102" height="40" xmlns="http://www.w3.org/2000/svg">
                <g transform="translate(2 1)" stroke="#002742" fill="none" fill-rule="evenodd" stroke-linecap="round"
                    stroke-linejoin="round">
                    <path class="car__body"
                        d="M47.293 2.375C52.927.792 54.017.805 54.017.805c2.613-.445 6.838-.337 9.42.237l8.381 1.863c2.59.576 6.164 2.606 7.98 4.531l6.348 6.732 6.245 1.877c3.098.508 5.609 3.431 5.609 6.507v4.206c0 .29-2.536 4.189-5.687 4.189H36.808c-2.655 0-4.34-2.1-3.688-4.67 0 0 3.71-19.944 14.173-23.902zM36.5 15.5h54.01"
                        stroke-width="3" />
                    <ellipse class="car__wheel--left" stroke-width="3.2" fill="#FFF" cx="83.493" cy="30.25" rx="6.922"
                        ry="6.808" />
                    <ellipse class="car__wheel--right" stroke-width="3.2" fill="#FFF" cx="46.511" cy="30.25" rx="6.922"
                        ry="6.808" />
                    <path class="car__line car__line--top" d="M22.5 16.5H2.475" stroke-width="3" />
                    <path class="car__line car__line--middle" d="M20.5 23.5H.4755" stroke-width="3" />
                    <path class="car__line car__line--bottom" d="M25.5 9.5h-19" stroke-width="3" />
                </g>
            </svg>
        </div>
    </div>
    <div v-else class="content contenedor">
        <div v-if="estadoproducto === 0" class="status-message not-found">
            <i :class="$t('icons.error')"></i>
            <p>{{ $t('status.notFound') }}</p>
        </div>
        <div v-else-if="estadoproducto === 2" class="status-message unavailable">
            <i :class="$t('icons.block')"></i>
            <p>{{ $t('status.unavailable') }}</p>
        </div>
        <div v-else>
            <div class="row" style="height: auto;">
                <!-- Primera columna -->
                <!-- Menú lateral -->
                <div class="col-12 col-md-2 order-2 order-md-1 d-none d-md-flex align-items-start flex-column text-black text-center p-3"
                    style="max-height: 100vh; overflow-y: auto;">
                    <!-- Botones -->
                    <div class="mb-3 d-flex align-items-center gap-2" @click="scrollToAplicaciones('ventas')"
                        style="cursor: pointer;">
                        <i class="bx bx-bar-chart custom-icon fs-4"></i>
                        <span class="fw-semibold">Sugerencias</span>
                        <span class="text-muted">(—)</span>
                    </div>

                    <div class="mb-3 d-flex align-items-center gap-2" v-if="detailsprods.aplicaciones.length > 0"
                        @click="scrollToAplicaciones('aplicaciones')" style="cursor: pointer;">
                        <i class="bx bx-cog custom-icon fs-4"></i>
                        <span class="fw-semibold">Aplicaciones</span>
                        <span class="text-muted">({{ detailsprods.aplicaciones.length }})</span>
                    </div>

                    <div class="mb-3 d-flex align-items-center gap-2"
                        v-if="detailsprods.conversiones.length > 0 || detailsprods.oems.length > 0"
                        @click="scrollToAplicaciones('conversionesproductos')" style="cursor: pointer;">
                        <i class="bx bx-sort custom-icon fs-4"></i>
                        <span class="fw-semibold">Conversiones</span>
                        <span class="text-muted">({{ detailsprods.conversiones.length + detailsprods.oems.length
                            }})</span>
                    </div>

                    <!-- Miniaturas debajo -->
                    <div class="w-100 mt-4" style="overflow-y: auto; overflow-x: hidden;">
                        <div class="row row-cols-2 g-2 mx-0">
                            <!-- Ver más imágenes -->
                            <div v-if="detailsprods.categorias[0].marcas.viewimages &&
                                Object.entries(detailsprods.PicturesUrl).length > detailsprods.categorias[0].marcas.viewimages.length"
                                class="col px-1">
                                <div @click="verTodasLasImagenes()"
                                    class="d-flex align-items-center justify-content-center bg-light border"
                                    style="width: 100%; height: 100px; cursor: zoom-in;"
                                    v-tooltip.top="'Ver galería de imágenes'">
                                    <span class="small text-center">
                                        {{
                                            Object.entries(detailsprods.PicturesUrl).length -
                                            detailsprods.categorias[0].marcas.viewimages.length
                                        }}+<br />imágenes
                                    </span>
                                </div>
                            </div>

                            <!-- Miniaturas definidas -->
                            <template v-if="detailsprods.categorias[0].marcas.viewimages">
                                <div v-for="(imagen, index) in detailsprods.categorias[0].marcas.viewimages"
                                    :key="'img-definida-' + index" class="col px-1">
                                    <template v-if="detailsprods.PicturesUrl[imagen.imagen]">
                                        <img :src="detailsprods.PicturesUrl[imagen.imagen].sm" alt=""
                                            @click="imagenselec(imagen.imagen)" loading="lazy"
                                            class="img-thumbnail w-100"
                                            style="height: 100px; object-fit: cover; cursor: pointer;" />
                                    </template>
                                </div>
                            </template>

                            <!-- Miniaturas alternativas si no hay viewimages -->
                            <template v-else>
                                <div v-for="i in [1, 3, 5, 7]" :key="'img-alternativa-' + i" class="col px-1"
                                    v-if="detailsprods.PicturesUrl[i]">
                                    <img :src="detailsprods.PicturesUrl[i].sm" alt="" @click="imagenselec(i)"
                                        loading="lazy" class="img-thumbnail w-100"
                                        style="height: 100px; object-fit: cover; cursor: pointer;" />
                                </div>
                            </template>
                        </div>
                    </div>

                </div>


                <!-- Segunda columna (Imagen) -->
                <div class="col-12 col-md-6 order-1 order-md-2 d-flex align-items-center justify-content-center text-black text-center p-3"
                    style="height: 100%;">
                    <div class="d-flex flex-column w-100">
                        <!-- Contenedor fijo para imagen grande -->
                        <div class="image-container mx-auto"
                            style="height: 400px; width: 100%; max-width: 600px; overflow: hidden; position: relative;">
                            <img v-if="detailsprods.PicturesUrl[imagenposicion]"
                                :src="detailsprods.PicturesUrl[imagenposicion].sm" alt="Descripción"
                                class="img-fluid grande" loading="lazy"
                                @click="openModal(detailsprods.PicturesUrl[imagenposicion].sm)"
                                v-tooltip.bottom="'Haz clic para hacer zoom'" style="
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          max-width: 100%;
          max-height: 100%;
          object-fit: contain;
          cursor: zoom-in;
        " />
                            <img v-else alt="Descripción" :src="getAbsoluteImageUrl('/img/display/Placeholder.png')"
                                loading="lazy" class="img-fluid grande" style="
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          max-width: 100%;
          max-height: 100%;
          object-fit: contain;
          cursor: default;
        " />
                        </div>
                    </div>
                </div>
                <!-- Tercera columna -->
                <div class="col-12 col-md-4 order-3 d-flex flex-column text-black text-center p-3">
                    <!-- Clave producto centrada con espacio -->
                    <div class="d-flex justify-content-start">
                        <h3 class="fw-bold card-title-kparte-details">
                            {{ detailsprods.k_parte }}
                        </h3>
                    </div>
                    <!-- Línea (h5 en negritas) y badges -->
                    <div class="d-flex justify-content-between align-items-center flex-wrap">
                        <h5 class="fw-bold card-text-linea-details">
                            {{ detailsprods.linea }}
                        </h5>
                        <div class="d-flex flex-wrap gap-2 justify-content-end" style="min-width: 180px;">
                            <BadgesProducto :item="detailsprods" wrapperClass="d-flex flex-wrap gap-2"
                                :fontSize="'13px'" />
                            <span v-if="detailsprods.PicturesUrl.length > 20" class="badge bg-warning text-dark"
                                @click="view360(detailsprods.PicturesUrl)" style="cursor: pointer; font-size: 14px;"
                                v-tooltip.top="`Click aquí para ver la imagen en 360°`">
                                360°
                            </span>

                            <i :class="$t('icons.shareAlt')" style="cursor: pointer; font-size: 18px; margin-left: 8px;"
                                @click="shareContent"></i>
                        </div>
                    </div>

                    <!-- Descripción -->
                    <p class="mb-3 card-text-descripcion">{{ detailsprods.descripcion }}</p>

                    <!-- Precio y carrito igual -->
                    <div v-if="(detailsprods.permisoprecios === '' || detailsprods.permisoprecios === null || detailsprods.permisoprecios === 1)"
                        class="mb-3 text-end">
                        <span class="price" style="font-size:34px;" v-if="detailsprods.precio_ajuste">
                            {{ formatearPrecio(detailsprods.precio_ajuste.valor) + ' ' +
                                detailsprods.precio_ajuste.sufijo }}
                        </span>
                    </div>

                    <div class="mb-3" v-if="detailsprods.ShoppingCart">
                        <car :ShoppingCart="detailsprods.ShoppingCart" :ShoppingCartParte="detailsprods.k_parte"
                            :ShoppingCartPromocion="detailsprods.promociones"></car>
                    </div>
                    <div class="mb-3" v-else-if="!detailsprods.ShoppingCart && isLoggedin">basg
                        <i class="fa fa-exclamation-triangle" aria-hidden="true" style="color: #FFFF00;"></i>
                        <p style="font-size: 10px; margin-left: 5px;">
                            Disculpa tenemos algunos inconvenientes no podemos habilitar las opciones de comprador
                        </p>
                    </div>
                    <div class="mb-3" v-else>
                        <p style="font-size: 10px;">
                            Las opciones de compra solo aparecen para clientes.
                            <router-link :to="{ name: 'Ingresa' }"
                                style="font-size: 12px; text-decoration: none; color: inherit; cursor: pointer;">
                                <strong>Inicia Sesión</strong>
                            </router-link>
                        </p>
                    </div>

                    <div class="mb-1" v-if="detailsprods.variante">
                        <viewsProdsVariante :variante="detailsprods.variante"></viewsProdsVariante>
                    </div>
                </div>
            </div>
            <!-- Bloque de Aplicaciones -->
            <div id="aplicaciones" class="w-100" style="margin-top: 0; padding-top: 1px; margin-bottom: 1%;"
                v-if="detailsprods.aplicaciones.length > 0" v-tooltip.top="`Click aquí para ver la compatibilidad`">
                <div class="row w-100 mt-0 pt-1 mx-0">
                    <div class="col-12 px-0">
                        <button @click="aplicacionesview()"
                            class="btn d-flex align-items-center w-100 py-3 boton-con-sombra"
                            style="font-size: 1.2rem; justify-content: space-between;">
                            <div>
                                <i class="bx bx-sort" style="font-size: 1.5rem; margin-right: 10px;"></i>
                                <strong>Ver información de compatibilidad del producto</strong>
                            </div>
                            <i class="bx bx-chevron-down" style="font-size: 1.5rem;"></i>
                        </button>
                    </div>
                </div>
            </div>

            <!-- Bloque de Conversiones -->
            <div id="conversionesproductos" class="w-100" style="margin-bottom: 5%;"
                v-tooltip.top="`Click aquí para ver códigos alterno`"
                v-if="filteredConversions.length > 0 || filteredOems.length > 0">
                <div class="row w-100 mx-0">
                    <div class="col-12 px-0">
                        <button @click="conversionesview()"
                            class="btn d-flex align-items-center w-100 py-3 boton-con-sombra"
                            style="font-size: 1.2rem; justify-content: space-between;">
                            <div>
                                <i class="bx bx-globe" style="font-size: 1.5rem; margin-right: 10px;"></i>
                                <strong>Ver códigos relacionados</strong>
                            </div>
                            <i class="bx bx-chevron-down" style="font-size: 1.5rem;"></i>
                        </button>
                    </div>
                </div>
            </div>

            <div class="text-start">
                <h3 class="fw-bold mb-3">💡 Recomendaciones</h3>
            </div>
            <div id="ventas" class="align-items-center w-100" style="margin-bottom: 1%;">
                <!-- Primer row con el ícono y el título, y el input -->
                <div class="row w-100">
                    <sugerencias :ProductoVer="claveprod"></sugerencias>
                </div>
            </div>

            <div class="text-start">
                <h3 class="fw-bold mb-3">🔗 Productos Relacionados</h3>
            </div>
            <div class="container">
                <!-- Título general -->
                <div class="row">
                    <!-- Columna izquierda: Lista de productos -->
                    <div class="col-md-4 border-end overflow-auto" style="max-height: 80vh;">
                        <div class="row g-2 p-2">
                            <div class="col-6" v-for="producto in productosCompatibles" :key="producto.id">
                                <div class="card h-100 cursor-pointer shadow-sm"
                                    :class="producto.id === productoSeleccionadocompatible?.id ? 'border border-primary' : 'border-0'"
                                    @click="seleccionarProducto(producto)"
                                    style="transition: transform 0.3s, box-shadow 0.3s;"
                                    v-tooltip.top="`Click aquí para ver más detalles de ${producto.k_parte}`"
                                    data-bs-toggle="tooltip" data-bs-placement="top">
                                    <!-- Imagen dinámica con fallback -->
                                    <div v-if="producto.PicturesUrl[
                                        producto.categorias &&
                                            producto.categorias.length &&
                                            producto.categorias[0].marcas.viewimagesprinc
                                            ? producto.categorias[0].marcas.viewimagesprinc
                                            : 4
                                    ]">
                                        <img :src="producto.PicturesUrl[
                                            producto.categorias &&
                                                producto.categorias.length &&
                                                producto.categorias[0].marcas.viewimagesprinc
                                                ? producto.categorias[0].marcas.viewimagesprinc
                                                : 4
                                        ].sm" alt="Imagen del producto" class="card-img-top" loading="lazy"
                                            style="height: 100px; object-fit: contain;" />
                                    </div>
                                    <div v-else>
                                        <img src="/img/display/Placeholder.png" alt="Imagen no disponible"
                                            loading="lazy" class="card-img-top"
                                            style="height: 100px; object-fit: contain;" />
                                    </div>

                                    <!-- Contenido de la card -->
                                    <div class="card-body p-2 text-center">
                                        <div>
                                            <h6 class="mb-1 fw-bold">{{ producto.k_parte }}</h6>
                                            <div class="text-muted small">{{ producto.linea }}</div>

                                            <p class="card-text small text-muted mb-0">
                                                {{ producto.descripcion?.substring(0, 50) }}...
                                            </p>
                                            <div v-if="producto.id === productoSeleccionadocompatible?.id"
                                                class="text-primary small">
                                                Viendo detalles</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Columna derecha: Detalle del producto seleccionado -->
                    <div class="col-md-8">
                        <div v-if="productoSeleccionadocompatible" class="p-3">

                            <div v-if="productoSeleccionadocompatible.PicturesUrl[
                                productoSeleccionadocompatible.categorias &&
                                    productoSeleccionadocompatible.categorias.length &&
                                    productoSeleccionadocompatible.categorias[0].marcas.viewimagesprinc
                                    ? productoSeleccionadocompatible.categorias[0].marcas.viewimagesprinc
                                    : 4
                            ]">
                                <img :src="productoSeleccionadocompatible.PicturesUrl[
                                    productoSeleccionadocompatible.categorias &&
                                        productoSeleccionadocompatible.categorias.length &&
                                        productoSeleccionadocompatible.categorias[0].marcas.viewimagesprinc
                                        ? productoSeleccionadocompatible.categorias[0].marcas.viewimagesprinc
                                        : 4
                                ].sm" alt="Imagen del producto" class="mb-3 d-block mx-auto rounded border"
                                    loading="lazy" style="height: 250px; object-fit: contain;" />
                            </div>
                            <div v-else>
                                <img src="/img/display/Placeholder.png" alt="Imagen no disponible" loading="lazy"
                                    class="mb-3 d-block mx-auto rounded border"
                                    style="height: 250px; object-fit: contain;" />
                            </div>
                            <h3 class="mb-2">{{ productoSeleccionadocompatible.k_parte }}</h3>
                            <p>{{ productoSeleccionadocompatible.linea }}</p>
                            <p>{{ productoSeleccionadocompatible.descripcion }}</p>

                            <h5 class="mt-4">Aplicaciones compatibles:</h5>
                            <div class="border rounded p-2 mt-2" style="max-height: 25vh; overflow-y: auto;">
                                <ul class="mb-0">
                                    <li v-for="app in productoSeleccionadocompatible.aplicaciones" :key="app.id"
                                        class="small">
                                        <span v-if="app.posicion && app.posicion !== '-'"><strong>{{ app.posicion
                                        }}</strong> - </span>
                                        <span v-if="app.traccion && app.traccion !== '-'"><strong>{{ app.traccion
                                        }}</strong> - </span>
                                        <span v-if="app.transmision && app.transmision !== '-'"><strong>{{
                                            app.transmision
                                                }}</strong> -
                                        </span>
                                        <span v-if="app.litros && app.litros !== '-'"><strong>{{ app.litros }}</strong>
                                            -
                                        </span>
                                        <span v-if="app.cilindros && app.cilindros !== '-'"><strong>{{ app.cilindros
                                        }}</strong> -
                                        </span>
                                        <span v-if="app.combustible && app.combustible !== '-'"><strong>{{
                                            app.combustible
                                                }}</strong> -
                                        </span>
                                        {{ app.marca }} - {{ app.modelo }} ({{ app.year }})
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div v-else class="p-3 text-muted">
                            <!-- Imagen de la marca si existe categoría y marca -->
                            <div
                                v-if="detailsprods.categorias && detailsprods.categorias.length && detailsprods.categorias[0].marcas">
                                <img :src="getAbsoluteImageUrl('/img/marcas/' + detailsprods.categorias[0].marcas.name + '.webp')"
                                    alt="Marca" class="mb-3 d-block mx-auto rounded border"
                                    style="height: 80px; object-fit: contain;" loading="lazy" />
                            </div>

                            <!-- Fallback si no hay categorías o marca -->
                            <div v-else class="text-muted text-center my-3">
                                <em>Selecciona un producto de la izquierda para ver más detalles</em>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- modal para dar clic a la imagen y hacer zoom -->
    <div class="modal fade" id="modalZoomVistaProd" data-bs-keyboard="false" tabindex="-1"
        aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="image-container" style="position: relative; overflow: hidden;">
                        <img :src="modalImage" alt="Image" class="modal-image" ref="zoomImage" @mousemove="zoomImage"
                            loading="lazy" @mouseleave="resetZoom" />
                        <div v-if="showLens" class="zoom-lens" :style="lensStyle"></div>
                    </div>
                </div>
                <div class="modal-footer">
                    <div class="zoom-controls d-flex justify-content-center gap-2 mb-3">
                        <button @click="zoomOut" class="btn btn-secondary" type="button">-</button>
                        <button @click="zoomIn" class="btn btn-secondary" type="button">+</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!--Modal 360°-->
    <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">
                        IMAGEN 360°
                    </h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div v-if="img360view.length > 1">
                        <view360 :ProductoVerSlider="img360view"></view360>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!--Modal para reporte de detalle con el producto-->
    <div class="modal fade" id="reporteProducto" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-md modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">Reporte Producto</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <form @submit.prevent="submitFormReporProds">
                        <div class="mb-3">
                            <label for="asunto" class="form-label">Asunto</label>
                            <select class="form-select" id="asunto" v-model="reporte.asunto">
                                <option v-for="opcion in opcionesAsunto" :key="opcion.valor" :value="opcion.valor">{{
                                    opcion.texto }}</option>
                                <!--<option v-if="usuarioAutenticado" value="opcionPersonalizada">Opción Personalizada</option>-->
                            </select>
                        </div>
                        <div class="mb-3">
                            <label for="nombre" class="form-label">Nombre</label>
                            <input type="text" class="form-control" id="nombre" v-model="reporte.nombre"
                                style="text-transform: uppercase;">
                        </div>
                        <div class="mb-3">
                            <label for="apellido" class="form-label">Apellido</label>
                            <input type="text" class="form-control" id="apellido" v-model="reporte.apellido"
                                style="text-transform: uppercase;">
                        </div>
                        <div class="mb-3">
                            <label for="correo" class="form-label">Correo</label>
                            <input type="email" class="form-control" id="correo" v-model="reporte.correo">
                        </div>
                        <div class="mb-3">
                            <label for="telefono" class="form-label">Teléfono</label>
                            <input type="text" class="form-control" id="telefono" v-model="reporte.telefono"
                                pattern="[0-9]*" maxlength="10">
                        </div>
                        <div class="mb-3">
                            <label for="detalle" class="form-label">Detalle</label>
                            <textarea class="form-control" id="detalle" rows="3" v-model="reporte.detalle"
                                style="text-transform: uppercase;"></textarea>
                        </div>
                        <button type="submit" class="btn btn-primary">Enviar</button>
                    </form>
                </div>
            </div>
        </div>
    </div>
    <!--nuevo modal para ver los detalles de las aplicaciones del producto-->
    <div class="modal fade" id="shareModalAplicciones" tabindex="-1" aria-labelledby="shareModalAplicciones"
        aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-xl"> <!-- Extra width -->
            <div class="modal-content" style="max-height: 100vh;"> <!-- Altura máxima fija -->
                <div class="modal-header">
                    <h5 class="modal-title">Lista de compatibilidad</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>

                <div class="modal-body d-flex p-0" style="height: 60vh;"> <!-- Altura fija interna -->
                    <div class="container-fluid px-3">
                        <div class="row w-100 h-100">
                            <!-- Columna marcas -->
                            <ul class="list-group col-12 col-md-4 overflow-auto" style="max-height: 100%;">
                                <li v-for="marca in marcas" :key="marca" class="list-group-item"
                                    :class="{ active: marca === marcaSeleccionada }" @click="seleccionarMarca(marca)"
                                    style="cursor:pointer">
                                    {{ marca }}
                                </li>
                            </ul>

                            <!-- Columna modelos -->
                            <ul class="list-group col-12 col-md-4 overflow-auto" style="max-height: 100%;">
                                <li v-for="modelo in modelosDeMarca" :key="modelo.modelo" class="list-group-item"
                                    :class="{ active: modelo.modelo === modeloSeleccionado?.modelo }"
                                    @click="seleccionarModelo(modelo)" style="cursor:pointer">
                                    {{ modelo.modelo }}
                                </li>
                            </ul>
                            <!-- Columna detalles -->
                            <div class="col-12 col-md-4" style="overflow-y: auto; max-height: 100%;">
                                <template v-if="modeloSeleccionado">
                                    <div v-for="yearInfo in modeloSeleccionado.years" :key="yearInfo.year" class="mb-2">
                                        <strong>{{ yearInfo.year }}</strong>
                                        <div><span v-if="yearInfo.cilindros !== '-'">Cilindros: {{ yearInfo.cilindros
                                        }}</span>
                                        </div>
                                        <div><span v-if="yearInfo.litros !== '-'">Litros: {{ yearInfo.litros }}</span>
                                        </div>
                                        <div><span v-if="yearInfo.combustible !== '-'">Combustible: {{
                                            yearInfo.combustible
                                                }}</span></div>
                                        <div><span v-if="yearInfo.traccion !== '-'">Tracción: {{ yearInfo.traccion
                                        }}</span>
                                        </div>
                                        <div><span v-if="yearInfo.posicion !== '-'">Posición: {{ yearInfo.posicion
                                        }}</span>
                                        </div>
                                        <div><span v-if="yearInfo.descripcion !== '-'">Descripción: {{
                                            yearInfo.descripcion
                                                }}</span></div>
                                    </div>
                                </template>
                                <template v-else>
                                    <p>Selecciona un modelo para ver detalles.</p>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!--Modal claves alternas-->
    <div class="modal fade" id="shareModalConversiones" tabindex="-1" aria-labelledby="shareModalConversiones"
        aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-xl"> <!-- Extra width -->
            <div class="modal-content" style="max-height: 100vh;"> <!-- Altura máxima fija -->
                <div class="modal-header">
                    <h5 class="modal-title">Lista de compatibilidad</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>

                <div class="modal-body p-0" style="height: 60vh;">
                    <div class="container-fluid h-100">
                        <div class="row h-100">

                            <!-- Columna Códigos Alternos -->
                            <div class="col-12 col-md-6 overflow-auto border-end" style="max-height: 100%;">
                                <div v-if="filteredConversions.length > 0">
                                    <h4 class="px-3 pt-2">Códigos Alternos</h4>
                                    <div class="table-responsive px-3">
                                        <table class="table table-hover text-center">
                                            <thead>
                                                <tr>
                                                    <th>Competencia</th>
                                                    <th>Código</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(conversion, index) in filteredConversions" :key="index">
                                                    <td style="vertical-align: middle;">{{ conversion.competencia }}
                                                    </td>
                                                    <td style="vertical-align: middle;">{{ conversion.codigo }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div v-else class="px-3">
                                    <h6 style="color:#FF9900;">Este producto no cuenta con conversiones que mostrar</h6>
                                </div>
                            </div>

                            <!-- Columna Ensambladora -->
                            <div class="col-12 col-md-6 overflow-auto" style="max-height: 100%;">
                                <div v-if="filteredOems.length > 0">
                                    <h4 class="px-3 pt-2">Ensambladora</h4>
                                    <div class="table-responsive px-3">
                                        <table class="table table-hover text-center">
                                            <thead>
                                                <tr>
                                                    <th>Ensambladora</th>
                                                    <th>Código</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(oem, index) in filteredOems" :key="index">
                                                    <td style="vertical-align: middle;">{{ oem.marca }}</td>
                                                    <td style="vertical-align: middle;">{{ oem.codigo }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div v-else class="px-3">
                                    <h6 style="color:#FF9900;">Este producto no cuenta con códigos de ensambladora</h6>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
    <!--Modal galeria de imagenes-->
    <div class="modal fade" id="modalVerTodasImagenes" tabindex="-1" aria-labelledby="modalVerTodasImagenes"
        aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-md"> <!-- más compacto -->
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Galería de Imágenes</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body p-0">
                    <div class="container-fluid d-flex flex-column">
                        <!-- Imagen principal (más chica) -->
                        <div class="d-flex align-items-center justify-content-center bg-light p-2"
                            style="height: 300px; width: 100%;">
                            <img :src="detailsprods.PicturesUrl?.[imagenSeleccionadaModal]?.sm || getAbsoluteImageUrl('/img/display/Placeholder.png')"
                                loading="lazy" class="img-fluid"
                                style="max-height: 100%; max-width: 100%; object-fit: contain;" />
                        </div>
                        <!-- Miniaturas abajo con scroll horizontal -->
                        <div class="d-flex align-items-center justify-content-start p-2"
                            style="overflow-x: auto; overflow-y: hidden; white-space: nowrap; height: 100px; width: 100%;">
                            <ul class="list-unstyled d-flex flex-row gap-2 mb-0" style="white-space: nowrap;">
                                <li v-for="(img, key) in detailsprods.PicturesUrl" :key="key"
                                    style="width: 80px; height: 80px; flex: 0 0 auto;">
                                    <div class="border rounded"
                                        :class="{ 'border-primary': imagenSeleccionadaModal === key }"
                                        style="width: 100%; height: 100%; overflow: hidden; cursor: pointer;"
                                        @click="imagenSeleccionadaModal = key">
                                        <img :src="img.sm" style="width: 100%; height: 100%; object-fit: cover;"
                                            loading="lazy" />
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>
<script>
import { defineAsyncComponent } from 'vue'
export default {
    components: {
        car: defineAsyncComponent(() => import('./carShop2.vue')),
        sugerencias: defineAsyncComponent(() => import(/* webpackChunkName: "SeccionProdsDestacarVistaProductos2" */'../navegation/ComponentsRecomend/CompoentsViews/SeccionProdsDestacarVistaProductos2.vue')),
        viewsProdsVariante: defineAsyncComponent(() => import(/* webpackChunkName: "productosviewVariantes" */'../navegation/ComponentsRecomend/CompoentsViews/productosviewVariantes.vue')),
        view360: defineAsyncComponent(() => import(/* webpackChunkName: "360" */'../navegation/ComponentsRecomend/Sliders/360.vue')),
        BadgesProducto: defineAsyncComponent(() => import(/* webpackChunkName: "Badges" */'../navegation/ComponentsRecomend/Sliders/Badges.vue')),
    },
    data() {
        return {
            loading: true,
            scrolled: false,
            showviewcart: window.Laravel.compras,
            viewprecios: window.Laravel.verprecios,
            claveprod: '',
            imagenposicion: 4,
            aplicacionselect: {},
            currentImageIndex: 0,
            isPlaying: false,
            playInterval: null,
            detailsprods: [],
            detailsaplicaciones: {},
            activeItem: null,
            filtro: '',
            aplicacionesfiltro: '',
            oems: {},
            responsiveOptions: {
                numVisible: 1,
                numScroll: 1,
            },
            scrolled: false,
            reporte: {
                asunto: '',
                nombre: '',
                apellido: '',
                correo: '',
                telefono: '',
                detalle: '',
                parte: '',
                linea: ''
            },
            opcionesAsunto: [
                { valor: 'FOTONOCORRESPONDE', texto: 'Foto no corresponde al producto' },
                { valor: 'FOTONOSEAPRECIA', texto: 'Foto no se aprecia correctamente' },
                { valor: 'CONVERSIONES', texto: 'Error en lista de conversiones' },
                { valor: 'APLICACIONES', texto: 'Error en lista compatibilidad / aplicaciones' },
                { valor: 'INFORMACION', texto: 'Error en información / incompleta' },
                //{ valor: 'INFORMACION', texto: 'Error en información / incompleta' },
                // Agrega más opciones aquí
            ],
            masproductoscart: [],
            prodscomplement: [],
            tendencias: [],
            responsiveOptions: [
                {
                    breakpoint: '1400px',
                    numVisible: 2,
                    numScroll: 1
                },
                {
                    breakpoint: '1199px',
                    numVisible: 3,
                    numScroll: 1
                },
                {
                    breakpoint: '767px',
                    numVisible: 2,
                    numScroll: 1
                },
                {
                    breakpoint: '575px',
                    numVisible: 1,
                    numScroll: 1
                }
            ],
            img360view: [],
            showModal: false,
            modalImage: '',
            showModal: false,
            showLens: false,
            lensStyle: { left: '0px', top: '0px' },
            zoomFactor: 1,       // zoom inicial 1 (sin zoom)
            minZoom: 1,
            maxZoom: 5,
            urlshare: window.location.href,  // Usa la URL actual de la página
            titleshare: 'Cecra',
            textshare: 'Producto a Recomendar',
            isShareSupported: false,
            estadoproducto: 1,
            marcaSeleccionada: null,
            modeloSeleccionado: null,
            imagenSeleccionadaModal: null,
            productosCompatibles: [],
            productoSeleccionadocompatible: null
        };
    },


    methods: {
        seleccionarProducto(producto) {
            if (this.productoSeleccionadocompatible?.id === producto.id) {
                this.productoSeleccionadocompatible = null;
            } else {
                this.productoSeleccionadocompatible = producto;
            }
        },
        verTodasLasImagenes() {
            if (this.detailsprods && this.detailsprods.PicturesUrl && Object.keys(this.detailsprods.PicturesUrl).length > 0) {
                const keys = Object.keys(this.detailsprods.PicturesUrl);
                this.imagenSeleccionadaModal = keys[0];
            } else {
                this.imagenSeleccionadaModal = null;
            }
            $('#modalVerTodasImagenes').modal('show')
        },
        seleccionarMarca(marca) {
            this.marcaSeleccionada = marca;
            this.modeloSeleccionado = null;
        },
        seleccionarModelo(modelo) {
            this.modeloSeleccionado = modelo;
        },
        aplicacionesview() {
            this.marcaSeleccionada = null;
            this.modeloSeleccionado = null;
            $('#shareModalAplicciones').modal('show');
            this.$nextTick(() => {
                // Esperamos a que se actualicen los computeds
                if (this.marcas.length > 0) {
                    this.marcaSeleccionada = this.marcas[0];

                    const modelos = this.modelosDeMarca;
                    if (modelos.length > 0) {
                        this.modeloSeleccionado = modelos[0];
                    }
                }
            });
        },
        conversionesview() {
            $('#shareModalConversiones').modal('show')
        },

        shareContent() {
            // Comprueba si el navegador soporta la API de compartir
            if (navigator.share) {
                // Llama a la API de compartir
                navigator.share({
                    title: this.titleshare,  // Título que aparece al compartir
                    text: this.textshare,    // Texto que acompaña al enlace
                    url: this.urlshare,      // URL que estás compartiendo
                })
                    .then(() => {
                        console.log('Contenido compartido exitosamente');
                    })
                    .catch((error) => {
                        console.error('Error al compartir:', error);
                    });
            } else {
                // En caso de que el navegador no soporte la API de compartir
                alert('La función de compartir no es compatible con tu navegador');
            }
        },
        scrollToAplicaciones(param) {
            // Usamos el parámetro para seleccionar dinámicamente el ID
            const element = document.getElementById(param);
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
            }
        },
        openModal(imageUrl) {
            this.modalImage = imageUrl;
            this.showModal = true;
            this.showLens = false;
            this.zoomFactor = 1;
            this.applyZoomCenter();
            $('#modalZoomVistaProd').modal('show');
        },
        closeModal() {
            this.showModal = false;
            this.modalImage = null;
            this.showLens = false;
        },
        zoomImage(event) {
            const lens = this.$refs.zoomImage;
            const lensWidth = 100;
            const lensHeight = 100;

            const { left, top, width, height } = lens.getBoundingClientRect();

            const mouseX = event.clientX - left;
            const mouseY = event.clientY - top;

            if (mouseX < 0 || mouseY < 0 || mouseX > width || mouseY > height) {
                this.resetZoom();
                return;
            }

            if (this.zoomFactor <= 1) {
                // Si no hay zoom no mostrar lente
                this.showLens = false;
                lens.style.transform = 'scale(1)';
                return;
            }

            this.showLens = true;

            this.lensStyle.left = `${mouseX - lensWidth / 2}px`;
            this.lensStyle.top = `${mouseY - lensHeight / 2}px`;

            lens.style.transform = `scale(${this.zoomFactor})`;
            lens.style.transformOrigin = `${(mouseX / width) * 100}% ${(mouseY / height) * 100}%`;
        },

        resetZoom() {
            this.showLens = false;
            const lens = this.$refs.zoomImage;
            lens.style.transform = `scale(${this.zoomFactor})`;
            lens.style.transformOrigin = '50% 50%';
        },

        zoomIn() {
            if (this.zoomFactor < this.maxZoom) {
                this.zoomFactor = Math.min(this.maxZoom, this.zoomFactor + 0.5);
                this.showLens = false;  // deshabilita lente en zoom por botón
                this.applyZoomCenter();
            }
        },

        zoomOut() {
            if (this.zoomFactor > this.minZoom) {
                this.zoomFactor = Math.max(this.minZoom, this.zoomFactor - 0.5);
                if (this.zoomFactor === 1) {
                    // reset zoom total cuando llegue a 1
                    this.showLens = false;
                    const lens = this.$refs.zoomImage;
                    lens.style.transform = 'scale(1)';
                    lens.style.transformOrigin = '50% 50%';
                } else {
                    this.showLens = false;
                    this.applyZoomCenter();
                }
            }
        },

        applyZoomCenter() {
            const lens = this.$refs.zoomImage;
            if (!lens) return;

            lens.style.transform = `scale(${this.zoomFactor})`;
            lens.style.transformOrigin = `50% 50%`;
        },
        getAbsoluteImageUrl(relativeUrl) {
            // Obtén la URL base de Laravel
            const baseUrl = window.location.origin;

            // Concatena la URL base con la ruta relativa de la imagen
            return baseUrl + relativeUrl;
        },
        handleScroll() {
            const container = this.$el.querySelector('.menu-container');
            // Verificar si el usuario se ha desplazado
            this.scrolled = container.scrollTop > 0;
        },
        formatearPrecio(valor) {
            // Asegurarse de que el valor sea un número
            const numero = Number(valor);

            // Verificar si el número es válido y no es NaN
            if (!isNaN(numero)) {
                // Formatear el número
                return numero.toLocaleString('es-MX', { style: 'currency', currency: 'MXN', minimumFractionDigits: 2 });
            } else {
                // Si no es un número válido, devolver un valor por defecto o un mensaje de error
                return 'Valor no válido';
            }
        },
        view360(imagenes) {
            this.img360view = imagenes
            $('#exampleModal').modal('show')

        },
        imagenselec(valueimg) {
            this.imagenposicion = valueimg
        },
        formatItem(value) {
            // Reemplazar "/" con "<br>" para los saltos de línea
            if (!value) {
                return ""; // O manejar el caso en que los datos no son válidos
            }
            //console.log(value)
            //const boldLetters = value.replace(/([A-Z]+)/g, '<strong>$1</strong>');
            const formattedText = value.replace(/\/\s*/g, '</span><br><span>');
            const boldText = `<span>${formattedText}</span>`;


            return boldText;

        },
        togglePlay() {
            this.isPlaying = !this.isPlaying;

            if (this.isPlaying) {
                // Iniciar reproducción automática
                this.playInterval = setInterval(() => {
                    // Avanzar a la siguiente imagen
                    this.currentImageIndex = (this.currentImageIndex + 1) % this.smImages.length;

                    // Verificar si se ha alcanzado la última imagen
                    if (this.currentImageIndex === 0) {
                        // Detener reproducción cuando se alcanza la última imagen
                        this.isPlaying = false;
                        clearInterval(this.playInterval);
                    }
                }, 100); // Ajusta el intervalo según tu preferencia
            } else {
                // Detener reproducción
                clearInterval(this.playInterval);
            }
        },
        rotateLeft() {
            // Lógica para rotar la imagen a la izquierda
            // Puedes, por ejemplo, decrementar el índice actual o realizar operaciones de rotación en la imagen si estás manejando la rotación del contenido de la imagen.
            // Actualizar currentImageIndex
            this.currentImageIndex = (this.currentImageIndex - 1 + this.smImages.length) % this.smImages.length;
        },

        rotateRight() {
            // Lógica para rotar la imagen a la derecha
            // Puedes, por ejemplo, incrementar el índice actual o realizar operaciones de rotación en la imagen si estás manejando la rotación del contenido de la imagen.
            // Actualizar currentImageIndex
            this.currentImageIndex = (this.currentImageIndex + 1) % this.smImages.length;
        },
        scrollToSummary() {
            const summarySection = document.getElementById('info');
            if (summarySection) {
                summarySection.scrollIntoView({ behavior: 'smooth' });
            }
        },
        // Método para desplazar la página a la sección de Compatibilidad
        scrollToCompatibility() {
            const compatibilitySection = document.getElementById('compatible');
            if (compatibilitySection) {
                compatibilitySection.scrollIntoView({ behavior: 'smooth' });
            }
        },
        // Método para desplazar la página a la sección de Conversiones
        scrollToConversions() {
            const conversionsSection = document.getElementById('conversion');
            if (conversionsSection) {
                conversionsSection.scrollIntoView({ behavior: 'smooth' });
            }
        },
        // Método para desplazar la página a la sección de Productos Relacionados
        scrollToRelatedProducts() {
            const relatedProductsSection = document.getElementById('relacionados');
            if (relatedProductsSection) {
                relatedProductsSection.scrollIntoView({ behavior: 'smooth' });
            }
        },
        // Método para desplazar la página a la sección de Compartir
        scrollToShare() {
            const shareSection = document.getElementById('hc');
            if (shareSection) {
                shareSection.scrollIntoView({ behavior: 'smooth' });
            }
        },
        changeImage(direction) {
            this.currentImageIndex = (this.currentImageIndex + direction + this.smImages.length) % this.smImages.length;
        },
        submitFormReporProds() {
            this.reporte.parte = this.detailsprods[0].k_parte;
            this.reporte.linea = this.detailsprods[0].linea;
            axios.post('/api/App/crearRepoProd', this.reporte)
                .then(response => {
                    // Muestra una alerta de éxito utilizando SweetAlert
                    this.reporte = {
                        asunto: '',
                        nombre: '',
                        apellido: '',
                        correo: '',
                        telefono: '',
                        detalle: '',
                        parte: '',
                        linea: ''
                    },
                        Swal.fire({
                            icon: 'success',
                            title: 'Éxito',
                            text: 'El formulario se ha enviado correctamente.',
                            confirmButtonColor: '#3085d6',
                            confirmButtonText: 'OK',
                            timer: 2000, // La alerta se cerrará automáticamente después de 2 segundos
                            timerProgressBar: true
                        });
                })
                .catch(error => {
                    // Muestra una alerta de error utilizando SweetAlert
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: 'Ha ocurrido un error al enviar el formulario.',
                        confirmButtonColor: '#d33',
                        confirmButtonText: 'OK',
                        timer: 2000, // La alerta se cerrará automáticamente después de 2 segundos
                        timerProgressBar: true

                    });
                    console.error('Error al enviar el formulario:', error);
                });
        },
        detailsprodsViews() {
            axios.get('/searchDetails/details', {
                params: {
                    claveprod: this.claveprod,
                    operacion: 1,
                }
            }).then((response) => {

                const isLoggedin = !response.data.loggin ? false : true;
                this.$store.dispatch('updateLoginStatus', isLoggedin);

                // También puedes actualizar window.Laravel si necesitas hacerlo globalmente
                window.Laravel.isLoggedin = isLoggedin;
                if (response.data.existeprods === 0 || response.data.existeprods === 2) {
                    this.estadoproducto = response.data.existeprods
                    this.loading = false
                    return;
                }
                this.detailsprods = response.data.results
                if (this.detailsprods &&
                    this.detailsprods.categorias[0] &&
                    this.detailsprods.categorias[0].marcas &&
                    this.detailsprods.categorias[0].marcas.viewimagesgde !== null) {
                    // La propiedad viewimagesprinc no es null
                    this.imagenposicion = this.detailsprods.categorias[0].marcas.viewimagesgde
                }
                this.loading = false
                //imagenposicion  categorias[0].marcas.viewimages
                //console.log(this.ajusteaplicaciones)



            }).catch((error) => {
                if (error.response && error.response.status === 429) {
                    const isLoggedin = false;

                    // Mostrar alerta de sesión expirada
                    Swal.fire({
                        title: 'Límite Excedido',
                        text: 'El limite de consultas se excedio. Por favor, ingresa como usuario.',
                        icon: 'warning',
                        confirmButtonText: 'Aceptar',
                    }).then(() => {
                        // Redirigir a la página de inicio de sesión
                        window.location.href = `${window.location.origin}/Ingresa`;
                    });
                } else {
                    console.log(error);
                }
            });

        },
        handleScroll() {
            // Verifica si la posición de desplazamiento es mayor que 0
            this.scrolled = window.scrollY > 0;
        },
        copyLink() {
            navigator.clipboard.writeText(this.urlshare).then(() => {
                alert('Enlace copiado al portapapeles');
            }, (err) => {
                console.error('Error al copiar el enlace:', err);
            });
        },
        async fetchProductosCompatibles() {
            try {
                const response = await axios.post('/searchDetails/productoscompatibles', {
                    producto_id: this.claveprod
                });

                this.productosCompatibles = response.data;
            } catch (error) {
                console.error('Error al obtener productos compatibles:', error);
            }
        }
        ////saca los productos de los carritos que se han vendido junto con el producto que estes viendo

    },
    beforeDestroy() {
    },
    mounted() {

        if (this.$route.params.id) {
            this.claveprod = this.$route.params.id;
            this.detailsprodsViews(); // Llama manualmente al método si es necesario
            this.fetchProductosCompatibles();
        }

    },
    computed: {
        facebookShareUrl() {
            return `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(this.urlshare)}`;
        },
        twitterShareUrl() {
            return `https://twitter.com/intent/tweet?url=${encodeURIComponent(this.urlshare)}&text=${encodeURIComponent(this.textshare)}`;
        },
        whatsappShareUrl() {
            return `https://api.whatsapp.com/send?text=${encodeURIComponent(this.textshare + ' ' + this.urlshare)}`;
        },
        ajusteaplicaciones() {
            let groupedByMarca = [];
            if (!this.detailsprods || !Array.isArray(this.detailsprods.aplicaciones)) {
                return [];
            }
            //console.log('cargando');

            this.detailsprods.aplicaciones.forEach(aplicacion => {
                let { marca, modelo, year, aspirado, combustible, descripcion, litros, motor, posicion, tipo, transmicion, cilindros, cuerpo, destacado, submodelo, traccion, valvulas, velocidades } = aplicacion;

                let marcaIndex = groupedByMarca.findIndex(item => item.marca === marca);
                if (marcaIndex === -1) {
                    groupedByMarca.push({ marca, years: [] });
                    marcaIndex = groupedByMarca.length - 1;
                }

                let modeloIndex = groupedByMarca[marcaIndex].years.findIndex(item => item.modelo === modelo);
                if (modeloIndex === -1) {
                    groupedByMarca[marcaIndex].years.push({ modelo, years: [] });
                    modeloIndex = groupedByMarca[marcaIndex].years.length - 1;
                }

                let years = year.split(',');
                years.forEach(yearRange => {
                    let [anioant, aniodesp] = yearRange.split('-');
                    let yearData = {
                        marca,
                        modelo,
                        aspirado,
                        year: yearRange,
                        combustible,
                        descripcion,
                        litros,
                        motor,
                        posicion,
                        tipo,
                        transmicion,
                        cilindros,
                        cuerpo,
                        destacado,
                        submodelo,
                        traccion,
                        valvulas,
                        velocidades,
                        anioant,
                        aniodesp
                    };
                    groupedByMarca[marcaIndex].years[modeloIndex].years.push(yearData);
                });
            });

            return groupedByMarca;
        },
        aplicacionesFiltradas() {
            const aplicaciones = this.ajusteaplicaciones; // Guardar el resultado en una constante.
            const filtro = this.aplicacionesfiltro.toLowerCase().trim(); // Asegúrate de que estés usando el input correcto

            if (!filtro) {
                // Agrupar aplicaciones por marca si no hay filtro
                return aplicaciones.reduce((agrupado, app) => {
                    if (!agrupado[app.marca]) {
                        agrupado[app.marca] = [];
                    }
                    agrupado[app.marca].push(app);
                    return agrupado;
                }, {});
            }

            const aplicacionesFiltradas = aplicaciones.map(app => {
                const modelosFiltrados = app.years.filter(modelo => {
                    const aniosFiltrados = modelo.years.filter(anio => {
                        const anioFiltrado = parseInt(filtro);

                        return (anio.anioant <= anioFiltrado && anio.aniodesp >= anioFiltrado) ||
                            (anio.motor && anio.motor.toLowerCase().includes(filtro)) ||
                            (anio.cilindros && anio.cilindros.toLowerCase().includes(filtro)) ||
                            (anio.litros && anio.litros.toString().toLowerCase().includes(filtro));
                    });

                    return aniosFiltrados.length > 0;
                });

                return { ...app, years: modelosFiltrados };
            }).filter(app => app.years.length > 0);

            // Agrupar las aplicaciones filtradas por marca
            return aplicacionesFiltradas.reduce((agrupado, app) => {
                if (!agrupado[app.marca]) {
                    agrupado[app.marca] = [];
                }
                agrupado[app.marca].push(app);
                return agrupado;
            }, {});
        },
        marcas() {
            return this.ajusteaplicaciones.map(app => app.marca);
        },
        modelosDeMarca() {
            const marca = this.marcaSeleccionada;
            if (!marca) return [];
            const marcaData = this.ajusteaplicaciones.find(app => app.marca === marca);
            return marcaData ? marcaData.years : [];
        },
        menuStyle() {
            return {
                top: this.scrolled ? '10%' : '18%' // Cambiar el valor de top según sea necesario
            };
        },
        filteredConversions() {
            // Si no hay ningún detalle de productos, devolvemos un array vacío
            if (!this.detailsprods || this.detailsprods.length === 0) {
                return [];
            }
            // Filtramos las conversiones según el texto ingresado en el campo de búsqueda
            return this.detailsprods.conversiones.filter(conversion =>
                conversion.competencia.toLowerCase().includes(this.filtro.toLowerCase()) ||
                conversion.codigo.toLowerCase().includes(this.filtro.toLowerCase())
            );
        },
        filteredOems() {

            // Si no hay ningún detalle de productos, devolvemos un array vacío
            if (!this.oems || Object.entries(this.oems).length === 0) {
                return [];
            }
            // Filtramos las conversiones según el texto ingresado en el campo de búsqueda
            return this.oems.filter(oem =>
                oem.marca.toLowerCase().includes(this.filtro.toLowerCase()) ||
                oem.codigo.toLowerCase().includes(this.filtro.toLowerCase())
            );
        },
        smImages() {
            if (this.detailsprods && Array.isArray(this.detailsprods) && this.detailsprods.length > 0) {
                const firstProduct = this.detailsprods;
                if (firstProduct && Array.isArray(firstProduct.PicturesUrl)) {
                    return firstProduct.PicturesUrl.filter(function (image) {
                        return image.sm;
                    });
                }
            }
            return [];
        },

        currentImageUrl() {
            return this.smImages[this.currentImageIndex] ? this.smImages[this.currentImageIndex].sm : '';
        },
        isLoggedin() {

            return this.$store.getters.isLoggedin
        },
    },
    watch: {
        '$route.params.id': {
            handler(newVal) {
                if (!newVal) {
                    //console.log('El valor de $route.params.id es vacío');
                    return; // Si el valor es vacío, no hacer nada
                }
                this.loading = true
                this.claveprod = newVal;
                this.detailsprodsViews();
                this.fetchProductosCompatibles();
                this.key += 1; // Incrementar la clave para forzar un nuevo renderizado
            },
            deep: true
        }
    },

};
</script>